import cslx from 'clsx';
import { FormStage } from '../CreateUserModal';

interface ProgressBarProps {
  currentStage: FormStage;
  className?: string;
}

const ProgressBar = (props: ProgressBarProps) => {
  const { currentStage, className } = props;
  let width;

  switch (currentStage) {
    case FormStage.Names:
      width = '33.33%';
      break;
    case FormStage.Phone:
      width = '66.66%';
      break;
    case FormStage.Address:
      width = '100%';
      break;
    default:
      width = '0%';
  }

  return (
    <div
      className={cslx(
        className,
        'w-full bg-secondary-grey h-0-8 rounded-14-0 overflow-hidden',
      )}
    >
      <div
        className="bg-primary-yellow h-full transition-all duration-200 ease-out"
        style={{ width }}
      ></div>
    </div>
  );
};

export default ProgressBar;
